"use client";

import { isChannel } from "@website/utils/channel/helpers";
import { AgenciesButton } from "@website/widget/header/components/agencies/agencies-button";
import { BackButton } from "@website/widget/header/components/back/back-button";
import { Logo } from "@website/widget/header/components/logo/logo";
import { MyTrips } from "@website/widget/header/components/my-trips/my-trips";
import { SupportAgent } from "@website/widget/header/components/support-agent/support-agent";
import { TravelServicesMobileDrawer } from "@website/widget/header/components/travel-services/TravelServicesMobileDrawer";
import { TravelServicesDesktop } from "@website/widget/header/components/travel-services/travel-services-desktop";
import { HeaderLogin } from "@website/widget/header/header-login/header-login";
import { HeaderPropertiesType } from "@website/widget/header/header.types";
import { LoginModal } from "@website/widget/login";
import { Suspense } from "react";

export const Header = ({
  showBackButton: showBackButtonParameter = false,
  isHomePage = false,
  minimalView,
  hideBackButton,
  title,
  customTitle,
  minimalLogo
}: HeaderPropertiesType) => {
  const isJek = isChannel(["jek"]);
  const isAndroidOrWebApp = isChannel(["jek"]);

  const showBackButton =
    !hideBackButton &&
    (showBackButtonParameter || isJek || (isAndroidOrWebApp && !isHomePage));
  const showAppModeTitle = (isJek || isAndroidOrWebApp) && Boolean(title);

  const showAuth = isChannel([
    "b2b",
    "website",
    "telesale",
    "web-app",
    "android",
    "safarmarket",
    "jek"
  ]);

  const showAgenciesButton = !minimalView && isChannel(["website"]);
  const showMyTrips =
    !minimalView &&
    isChannel([
      "website",
      "telesale",
      "web-app",
      "android",
      "safarmarket",
      "jek"
    ]);
  const showTravelServices =
    !minimalView &&
    !showBackButton &&
    isChannel(["website", "telesale", "web-app", "android", "safarmarket"]);
  return (
    <div className="border-b-outline-thin relative z-30 flex h-16 w-full border-b bg-white px-4 lg:z-40 lg:px-6 xl:px-10">
      <div className="mx-0 flex size-full items-center gap-2 lg:gap-4 xl:mx-auto xl:w-[1200px]">
        <nav className="flex h-full items-center gap-2 lg:gap-4">
          {showBackButton && (
            <Suspense>
              <BackButton isHomePage={isHomePage} />
            </Suspense>
          )}
          {showTravelServices && <TravelServicesMobileDrawer />}
          {showAppModeTitle ? (
            <div className="text-headline-6 font-normal">{title}</div>
          ) : (
            <>
              <Logo minimalLogo={minimalLogo} />
              {Boolean(customTitle) && (
                <>
                  <div className="bg-outline-thin -ms-1 me-1 h-[32px] w-px lg:-ms-2 lg:me-0 lg:h-[40px]" />
                  <div className="text-on-surface-medium-emphasis text-sm font-bold lg:text-base">
                    {customTitle}
                  </div>
                </>
              )}
            </>
          )}
          {showTravelServices && <TravelServicesDesktop />}
          {showAgenciesButton && <AgenciesButton />}
        </nav>
        <div className="flex-1" />
        {showMyTrips && (
          <Suspense>
            <MyTrips />
          </Suspense>
        )}
        <SupportAgent isHomePage={isHomePage} />
        {showAuth && (
          <Suspense>
            <HeaderLogin />
          </Suspense>
        )}
      </div>
      <Suspense>
        <LoginModal />
      </Suspense>
    </div>
  );
};
